//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api_GetReqItemlog } from "../../../api";
import { conversion } from "../../../tool";

export default {
	data() {
		return {
			walletData: {
				data: { list: [] },
				current: 1,
				size: 15
			},
		}
	},
	methods: {
		//翻页接口
		getuserBalance(obj) {
			api_GetReqItemlog(obj).then(res => {
				if (res.data.code === 0) {
					this.walletData.data.list = res.data.data.data;
					this.walletData.data.total = res.data.data.totalItems;
				}
			});
		},
		//翻页
		pageF(v) {
			this.getuserBalance({ page: v, size: this.walletData.size });
		},
	},
	filters: {
		conversion,
		add(v) {
			return v > 0 ? `+${v}` : v;
		}
	},
	created() {
		this.getuserBalance({
			page: this.walletData.current,
			size: this.walletData.size
		});
	},
	name: "walletHistory"
}
